import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { BQLink } from '../../../../atoms/bqlink';
import Loader from '../../../../atoms/icons/loader';
import { ArrowRightIcon } from '../../../../atoms/material-icons';
import EmptyState from '../empty-state';
import './greatest-premium-discount-futures.m.css';
import { isWithinTradingHours, widgetLink } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

const GreatestPremiumDiscountFutures = ({ widget = false }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [premiumDiscountData, setPremiumDiscountData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState('stocks-at-premium');
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getPremiumDiscountData = async (filterValue = 'stocks-at-premium') => {
    const response = await fetch(
      `/foapi/future/getByPremiumDiscount?premium=${filterValue === 'stocks-at-premium' ? '1' : '0'}&limit=8&order=${filterValue === 'stocks-at-premium' ? '1' : '0'}`,
    );
    return response.json();
  };

  const resultPremiumDiscountData = useQuery(
    'getPremiumDiscountData',
    () => getPremiumDiscountData(selectedFilter),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setPremiumDiscountData(data?.data);
      },
      enabled:
        initialLoading ||
        (!!selectedFilter && isWithinTradingHours(tradingHolidays, specialTradingDays)),
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (resultPremiumDiscountData?.isSuccess) {
      setPremiumDiscountData(resultPremiumDiscountData?.data?.data);
    }
  }, []);

  const clickHandler = async (type) => {
    setLoading(true);
    setSelectedFilter(type);
    const data = await getPremiumDiscountData(type);
    setPremiumDiscountData(data?.data);
    setLoading(false);
  };

  return (
    <React.Fragment>
      {initialLoading ? (
        <div styleName="initial-loading-container"></div>
      ) : (
        <div styleName={`open-interest-container ${widget ? 'widget-mode' : ''}`}>
          <div styleName="btn-container">
            <button
              styleName={`filter-btn ${selectedFilter === 'stocks-at-premium' ? 'selected' : ''}`}
              onClick={() => clickHandler('stocks-at-premium')}
            >
              Greatest Premium
            </button>
            <button
              styleName={`filter-btn ${selectedFilter === 'stocks-at-discount' ? 'selected' : ''}`}
              onClick={() => clickHandler('stocks-at-discount')}
            >
              Greatest Discount
            </button>
          </div>
          {premiumDiscountData && premiumDiscountData?.length !== 0 ? (
            <>
              {loading ? (
                <div styleName="loading-container-ext">
                  <div styleName="loading-container-int">
                    <Loader color={'#dadee1'} />
                  </div>
                </div>
              ) : (
                <div styleName="table-body-container">
                  <table styleName="main-table">
                    <thead styleName="table-header">
                      <tr>
                        <th styleName="column-title">Security</th>
                        <th styleName="column-title-alt">Expiry</th>
                        <th styleName="column-title-alt">
                          {selectedFilter === 'stocks-at-premium' ? 'Premium' : 'Discount'}
                        </th>
                        <th styleName="column-title-alt">
                          {selectedFilter === 'stocks-at-premium' ? '% Premium' : '% Discount'}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {premiumDiscountData &&
                        premiumDiscountData?.map((interestValue, index) => (
                          <tr styleName="data-row" key={index}>
                            <td>
                              {interestValue?.symbol ? (
                                <BQLink
                                  href={widgetLink(
                                    `/markets/futures-contract/${interestValue?.symbol}${widgetParam}`,
                                  )}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <span styleName="name">{interestValue?.symbol}</span>
                                </BQLink>
                              ) : (
                                <span styleName="name">-</span>
                              )}
                            </td>
                            <td styleName="column-value">
                              {moment(interestValue['expiry-date']).format('DD MMM')}
                            </td>
                            <td styleName="column-value">
                              {interestValue['premium-discount'] ? (
                                <span>
                                  {String(interestValue['premium-discount']).includes('-') ? (
                                    <span styleName="negative-value">
                                      {`${interestValue['premium-discount']?.toFixed(2)}`}
                                    </span>
                                  ) : (
                                    <span styleName="positive-value">
                                      {`+${interestValue['premium-discount']?.toFixed(2)}`}
                                    </span>
                                  )}
                                </span>
                              ) : (
                                <span>-</span>
                              )}
                            </td>
                            <td styleName="text-alignment">
                              {interestValue['premium-discount-percentage'] ? (
                                <span>
                                  {String(interestValue['premium-discount-percentage']).includes(
                                    '-',
                                  ) ? (
                                    <span styleName="negative-value">
                                      {`${interestValue['premium-discount-percentage']}%`}
                                    </span>
                                  ) : (
                                    <span styleName="positive-value">
                                      {`+${interestValue['premium-discount-percentage']}%`}
                                    </span>
                                  )}
                                </span>
                              ) : (
                                <span>-</span>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : (
            <div styleName="no-data-container-ext">
              <div styleName="no-data-container-int">
                <EmptyState />
              </div>
            </div>
          )}

          {!widget && (
            <div>
              <BQLink
                styleName="view-more-btn"
                href={widgetLink(
                  `/markets/futures-contract/greatest-premium-and-discount${widgetParam}`,
                  widget,
                )}
                target="_blank"
                rel="noreferrer"
              >
                View All <ArrowRightIcon styleName="tab-icon" color={'#2b2b2b'} />
              </BQLink>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default GreatestPremiumDiscountFutures;
